import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_SourceWrap = _resolveComponent("SourceWrap")

  return ($options.show_more)
    ? (_openBlock(), _createBlock(_component_SourceWrap, {
        key: 0,
        ref: "view",
        class: "view-more",
        pointer: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.extra_items, (source) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: source }, [
              (source.type === 'file')
                ? (_openBlock(), _createBlock(_component_FileIcon, {
                    key: 0,
                    "font-size": "0.5rem",
                    width: "1.28rem",
                    height: "1.6rem",
                    ext: source.type
                  }, null, 8 /* PROPS */, ["ext"]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "rest-icon",
                    src: source.logo || '/assets/icons/cube-02.svg'
                  }, null, 8 /* PROPS */, _hoisted_1))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("span", _hoisted_2, " View " + _toDisplayString($options.rest_count) + " more ", 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */))
    : _createCommentVNode("v-if", true)
}